import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isAscLoginPath } from '../config/routes';

// Map of routes to page titles
const routeTitleMap = {
  '/': 'Home',
  '/login': 'Login',
  '/dashboard': 'Dashboard',
  '/patients': 'Patient Management',
  '/patient-management': 'Patient Management',
  '/preop-summary': 'Summary',
  '/patient-summary': 'Summary',
  '/patient': 'Summary',
  '/settings': 'Settings',
  '/profile': 'User Profile',
  '/admin': 'Admin Panel',
  '/greenfield-surgeries': 'Greenfield Surgeries',
  '/protocols': 'Protocol Management',
  '/review-queue': 'Review Queue',
  '/questionnaires/review': 'Review Queue',
  '/documentation': 'Documentation',
  '/asc/login': 'ASC Login',
  '/asc/dashboard': 'ASC Dashboard',
  '/asc/patient-management': 'ASC Patient Management',
  '/asc/patients': 'ASC Patient Management',
  '/asc/preop-summary': 'Summary',
  '/asc/facilities': 'Facility Management',
  '/asc/surgeries': 'Surgery Schedule',
  '/asc/protocols': 'ASC Protocol Management',
  '/asc/surgeons': 'Surgeon Management',
  '/asc/review-queue': 'Review Queue',
  '/asc/questionnaires/review': 'Review Queue',
};

/**
 * Component that automatically updates the page title based on the current route
 */
function PageTitleHandler() {
  const location = useLocation();

  useEffect(() => {
    const BASE_TITLE = 'VirtualPAT';

    if (isAscLoginPath(location.pathname, location.search)) {
      document.title = `ASC Login | ${BASE_TITLE}`;
      return;
    }

    // Find the most specific route that matches the current path
    const matchedRoutes = Object.keys(routeTitleMap)
      .filter(route => location.pathname.startsWith(route))
      .sort((a, b) => b.length - a.length); // Sort by specificity (longest match first)

    // Base title for the application
    if (matchedRoutes.length > 0) {
      const pageTitle = routeTitleMap[matchedRoutes[0]];
      document.title = `${pageTitle} | ${BASE_TITLE}`;
    } else {
      // Default fallback if no route matches
      document.title = BASE_TITLE;
    }
  }, [location.pathname, location.search]);

  // This component doesn't render anything visible
  return null;
}

export default PageTitleHandler;
